import { atom } from "jotai";

export const pageDrawerAtom = atom<boolean, boolean | undefined>(
  false,
  (get, set, nextValue?: boolean) => {
    const update =
      typeof nextValue === "boolean" ? nextValue : !get(pageDrawerAtom);
    set(pageDrawerAtom, update);
  }
);
